import * as React from 'react';
import { connect } from 'react-redux';

import * as FindUserActions from '../../actions/findUser';

import State from '../../interfaces/states/State';
import UserInfoResponse from '../../interfaces/UserInfoResponse';
import NavigationDescription from '../../interfaces/NavigationDescription';

interface DispatchProps {
  activeTabAction: (value: number) => void;
}

interface OwnProps {
  userInfo: UserInfoResponse | {};
  activeTab: number;
  item: number;
  activeImage: any;
  image: any;
  navLength: NavigationDescription[];
  text: string;
}

interface Props extends DispatchProps, OwnProps {}

function NavigationItem (props: Props) {
  
  const showNewNode = React.useCallback(() => {
    props.activeTabAction(props.item);
  }, [props.activeTabAction, props.item]);

  return(
    <div>
      {
        <div
          className='d-flex justify-around align-center'
          onClick={showNewNode} >
          <div
            className={props.item === props.activeTab
              ? 'nav-item-active d-flex justify-around align-center' : 'nav-item d-flex justify-around align-center'}>
            <img
              className='nav-image'
              src={props.item === props.activeTab ? props.activeImage : props.image} />
            <span className={props.item === props.activeTab ? 'nav-text nav-text-active' : 'nav-text'}>
              {props.text}
            </span>
          </div>
          {
            props.navLength.length - 1 === props.item ||
              props.item === props.activeTab ||
              props.item === props.activeTab - 1 ?
              null :
              <div className='nav-line' />
          }
        </div>
      }
    </div>
  );

}

const mapStateToProps = (state: State) => {
  return {
    userInfo: state.findUser.userInfo,
    activeTab: state.findUser.activeTab,
  };
};

const mergeProps = (stateProps, dispatchProps: DispatchProps, props: OwnProps): Props => {
  return {
    ...stateProps,
    activeTabAction: dispatchProps.activeTabAction,
    ...props,
  };
};

export default connect(
  mapStateToProps, {
    activeTabAction: FindUserActions.fetchActiveTabAction,
  }, mergeProps
)(React.memo(NavigationItem));
